import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '@core/services/account.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpError, HttpErrorHandlerService } from '../services/http-error-handler.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private httpErrorHandler: HttpErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const request = req.clone({ setHeaders: { 'X-Requested-With': 'XMLHttpRequest' } });
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          if (
            error.status === HttpError.InternalServerError ||
            (error.status === HttpError.Forbidden && !this.router.url.includes('admin')) ||
            error.status === HttpError.Validation
          ) {
            this.httpErrorHandler.handleError(error.status, error);
            error = { ...error, error: { ...error.error, handled: true } };
          }
          if (error.status === HttpError.Forbidden && this.router.url.includes('admin')) {
            this.accountService.loadUser();
            this.router.navigate(['/error', '403'], { relativeTo: this.route });
          }
        }
        return throwError(error);
      })
    );
  }
}
